class ValidationService {
    static hasCapital(value) {
        if (value) {
            return /[A-Z]/.test(value); // eslint-disable-line no-useless-escape
        }
        return false;
    }

    static hasLower(value) {
        if (value) {
            return /[a-z]+/.test(value); // eslint-disable-line no-useless-escape
        }
        return false;
    }

    static hasNum(value) {
        if (value) {
            return /[0-9]/.test(value); // eslint-disable-line no-useless-escape
        }
        return false;
    }

    static hasChars(value) {
        if (value) {
            return /[^A-Za-z0-9]/.test(value); // eslint-disable-line no-useless-escape
        }
        return false;
    }

    static hasLength(value) {
        if (value) {
            return value.length > 7;
        }
    }
}

export default ValidationService;